import "react";
import { useTranslation as e } from "@maat/store-i18n";
import { Collapsible as t, styled as n } from "@maat/ds-core";
import { jsx as r } from "react/jsx-runtime";
//#region src/ErrorFallback/ErrorDetails.tsx
var i = n.pre`
    margin: ${({ theme: e }) => e.spacing(1)} 0 0;
    padding: ${({ theme: e }) => e.spacing(1.5)};
    max-height: 220px;
    overflow: auto;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-word;
    font-family: ui-monospace, 'Cascadia Code', 'Source Code Pro', monospace;
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    line-height: ${({ theme: e }) => e.typographyTokens.lineHeights.normal};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    background: ${({ theme: e }) => e.colors.accent};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.md};
`, a = ({ error: n, componentStack: a }) => {
	let { t: o } = e("common"), s = (n.stack || `${n.name}: ${n.message}`) + (a ? `\n\nComponent stack:${a}` : "");
	return /* @__PURE__ */ r(t, {
		title: o("errors.details"),
		children: /* @__PURE__ */ r(i, { children: s })
	});
};
//#endregion
export { a as ErrorDetails };
